import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import {
  StrapiVideoSectionDTO,
  VideoSectionDTO,
} from "@lib/strapi/dtos/components/sections/videoSection.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { getImageProps, ImageProps } from "@lib/image";

export class VideoSectionService {
  static async fromStrapi(
    locale: string,
    strapiData?: StrapiVideoSectionDTO,
  ): Promise<VideoSectionDTO> {
    if (!strapiData) {
      return null;
    }
    const dto = new VideoSectionDTO();
    Object.assign(
      dto,
      await DynamicZoneComponentDTO.fromStrapi(locale, strapiData),
    );
    dto.heading = strapiData.heading;
    dto.intro = await parseStrapiContent(strapiData.intro);
    dto.video = getImageProps(strapiData.video);
    dto.externalUrl = strapiData.externalUrl;
    dto.poster = getImageProps(strapiData.poster);
    return dto;
  }
}
